import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CityModel } from 'src/app/models/management/city.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CityTableModel } from 'src/app/models/tables/management/city-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private _httpClient: HttpClient) { }

  createCity(cityModel: CityModel): Observable<CityModel> {
    return this._httpClient.post<CityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.CreateCity}`,
      cityModel);
  }

  deleteCity(cityId: number): Observable<CityModel> {
    return this._httpClient.delete<CityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.DeleteCity}/${cityId}`);
  }

  getAllCitiesByCountry(countryId: number): Observable<Array<CityModel>> {
    return this._httpClient.get<Array<CityModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetAllCitiesByCountry}/${countryId}`)
  }

  getCityDepartment(cityId: number): Observable<string> {
    const params = new HttpParams().set('cityId', cityId);
    return this._httpClient.get<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetCityDepartmentAsync}`,
      { params: params }
    );
  }

  getAllCitiesByDepartmentIdForSelect(departmentId: number): Observable<any[]> {
    const params = new HttpParams().set('departmentId', departmentId)
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetAllCitiesByDepartmentIdForSelectAsync}`,
      { params: params }
    );
  }

  getAllCitiesByCountryIdForSelectAsync(countryId: number): Observable<any[]> {
    const params = new HttpParams().set('countryId', countryId)
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetAllCitiesByCountryIdForSelectAsync}`,
      { params: params }
    );
  }

  getCitiesForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<CityTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<CityTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetCitiesForSelection}`,
      filters, { params: params }
    );
  }

  getCityByCode(departmentId: number, code: string): Observable<CityModel> {
    const params = new HttpParams()
      .set('departmentId', departmentId)
      .set('code', code || '')
    return this._httpClient.get<CityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetCityByCode}`, { params: params })
  }

  getCityById(cityId: number): Observable<CityModel> {
    return this._httpClient.get<CityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetByIdAsync}/${cityId}`)
  }

  getColumnsForCitySelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetColumnsForCitySelection}`);
  }

  GetByDepartmentId(departmentId: number): Observable<Array<CityModel>> {
    return this._httpClient.get<Array<CityModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.GetByDepartmentId}/${departmentId}`)
  }

  updateCity(cityModel: CityModel): Observable<CityModel> {
    return this._httpClient.put<CityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.city.UpdateAsync}`,
      cityModel);
  }
}
